"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareResourceSearch = void 0;
var react_1 = __importDefault(require("react"));
var validator_1 = __importDefault(require("validator"));
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var PermissionTypes_1 = require("../../../DataStores/Permissions/PermissionTypes");
var OnClickOutside_1 = __importDefault(require("CommonUI/OnClickOutside/OnClickOutside"));
var BlankOrInvite_1 = require("../../Expansion/BlankOrInvite/BlankOrInvite");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var CardsWithSuccessTransition_1 = require("./CardsWithSuccessTransition/CardsWithSuccessTransition");
var InviteNewUser_1 = require("Common/InviteNewUserModal/InviteNewUser");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var PermissionsDropdown_1 = require("Common/Permissions/PermissionsDropdown/PermissionsDropdown");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ShareResourceSearch = (function (_super) {
    __extends(ShareResourceSearch, _super);
    function ShareResourceSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.userResults = [];
        _this.teamResults = [];
        _this.showingSearchResults = false;
        _this.showError = false;
        _this.searchTerm = "";
        _this.permission = Types_1.Action.Edit;
        _this.userMatchesSearch = function (user) {
            switch (user.type) {
                case PermissionTypes_1.UserType.Existing:
                    return ((user.email || "").toLowerCase().includes(_this.searchTerm.toLowerCase()) ||
                        (user.firstName || "").toLowerCase().includes(_this.searchTerm.toLowerCase()) ||
                        (user.lastName || "").toLowerCase().includes(_this.searchTerm.toLowerCase()));
                case PermissionTypes_1.UserType.Pending:
                    return user.email.toLowerCase().includes(_this.searchTerm.toLowerCase());
                default:
                    throw new Error("Unknown UserPermissionType: ".concat(JSON.stringify(user)));
            }
        };
        _this.onSearchValueChange = function (searchTerm) {
            _this.searchTerm = searchTerm;
            if (searchTerm !== "") {
                if (_this.hasUnpermittedUsersOrTeams) {
                    _this.showSearchResults(true);
                }
                else {
                    setTimeout(function () {
                        _this.showSearchResults(true);
                    }, 1500);
                }
            }
        };
        _this.clearSearch = function () {
            _this.searchTerm = "";
            _this.showingSearchResults = false;
            _this.userResults = [];
            _this.teamResults = [];
        };
        _this.onSelectPermission = function (entityId, permission) {
            _this.permission = permission;
        };
        _this.showSearchResults = function (show) {
            _this.showingSearchResults = show;
        };
        _this.handleClickInvite = function () { return __awaiter(_this, void 0, void 0, function () {
            var hasInvited;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.inviteUserToQwilr(this.searchTerm, this.permission)];
                    case 1:
                        hasInvited = _a.sent();
                        if (hasInvited) {
                            setTimeout(function () {
                                _this.showSearchResults(false);
                                _this.onSearchValueChange("");
                            }, 1000);
                        }
                        else {
                            throw Error();
                        }
                        return [2];
                }
            });
        }); };
        _this.handleOnClick = function (event) {
            var _a = _this.props, userInvitePermission = _a.userInvitePermission, userDataStore = _a.userDataStore;
            if (userInvitePermission === Types_1.UserInvitePermission.Domain &&
                !userDataStore.isAdmin &&
                !(0, InviteNewUser_1.isInvitedUserFromSameDomain)(userDataStore, _this.searchTerm) &&
                _this.blankOrInvite.current &&
                _this.blankOrInvite.current.contains(event.target)) {
                _this.showError = true;
            }
            else {
                _this.showError = false;
            }
        };
        _this.handleKeyDown = function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (event.key === "Escape" && this.searchTerm.trim().length === 0 && this.showingSearchResults) {
                            this.showSearchResults(false);
                            event.stopPropagation();
                        }
                        if (!(event.key === "Enter" && validator_1.default.isEmail(this.searchTerm))) return [3, 2];
                        return [4, this.handleClickInvite()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        _this.onSearchInputFocus = function () {
            _this.showSearchResults(_this.hasUnpermittedUsersOrTeams);
        };
        _this.onCardClickWrapper = function (cardClickHandler, id, permission) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, cardClickHandler(id, permission)];
                    case 1:
                        _a.sent();
                        if (this.userResults.length + this.teamResults.length === 0) {
                            setTimeout(function () {
                                _this.showSearchResults(false);
                            }, 1400);
                        }
                        return [2];
                }
            });
        }); };
        _this.blankOrInvite = react_1.default.createRef();
        _this.onClickOutside = new OnClickOutside_1.default([".share-resource-search", ".modal-container"], function () {
            _this.clearSearch();
            _this.onClickOutside.startListening();
        }, setTimeout.bind(window), UniqueId_1.default);
        return _this;
    }
    ShareResourceSearch.prototype.render = function () {
        this.filterResults();
        var hasResults = this.userResults.length + this.teamResults.length > 0;
        return (react_1.default.createElement("div", { className: "share-resource-search" },
            react_1.default.createElement("div", { onKeyDown: this.handleKeyDown },
                react_1.default.createElement(kaleidoscope_1.SearchInput, { className: (0, classnames_1.default)("share-resource-search__input", {
                        "share-resource-search__input--showing-results": this.showingSearchResults,
                    }), onFocus: this.onSearchInputFocus, onChange: this.onSearchValueChange, label: "Search users by name or email", placeholder: "Enter a name or email", value: this.searchTerm })),
            this.showingSearchResults && (react_1.default.createElement("div", { className: "share-resource-search__permission" },
                react_1.default.createElement(PermissionsDropdown_1.PermissionsDropdown, { directPermission: this.permission, handlePermissionChange: this.onSelectPermission, availablePermissions: this.props.availablePermissions, allowRemove: false }))),
            this.showingSearchResults && (react_1.default.createElement(kaleidoscope_2.Tooltip, { className: "share-resource-error-tooltip", wrapTarget: true, size: kaleidoscope_2.TooltipSize.Large, position: kaleidoscope_2.TooltipPosition.Top, show: this.showError, content: "You can only invite users who share the same domain as you" },
                react_1.default.createElement("div", { onClick: this.handleOnClick },
                    react_1.default.createElement(react_addons_css_transition_group_1.default, { component: CardsWithSuccessTransition_1.TransitionContainer, transitionName: "share-resource-search-delay-unmount", transitionEnterTimeout: 1400, transitionLeaveTimeout: 1400 }, hasResults ? (react_1.default.createElement("div", { key: "search-results", className: "share-resource-search__results" }, this.renderResults())) : (react_1.default.createElement("div", { key: "blank-search-results", className: "share-resource-search__results share-resource-search__results--no-results" }, this.renderBlankSearchResults()))))))));
    };
    ShareResourceSearch.prototype.renderResults = function () {
        var cards = __spreadArray(__spreadArray([], __read(this.renderTeamCards()), false), __read(this.renderUserCards()), false);
        return (react_1.default.createElement("div", { key: "results-inner", className: "share-resource-search__results__inner" },
            react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "share-resource-card-transition", transitionEnter: false, transitionLeaveTimeout: 1400 }, cards)));
    };
    ShareResourceSearch.prototype.renderBlankSearchResults = function () {
        var _this = this;
        var isValidEmail = validator_1.default.isEmail(this.searchTerm);
        if (isValidEmail) {
            var matchedUser = this.props.permittedUsers.filter(function (user) { return user.email === _this.searchTerm; });
            if (matchedUser.length > 0) {
                return react_1.default.createElement(BlankOrInvite_1.BlankCard, { text: "".concat(this.searchTerm, " already invited") });
            }
        }
        return (react_1.default.createElement("div", { key: "blank-or-invite", className: "share-resource-search__results__inner", ref: this.blankOrInvite },
            react_1.default.createElement(BlankOrInvite_1.BlankOrInvite, { onClickInvite: this.handleClickInvite, showInvite: isValidEmail })));
    };
    ShareResourceSearch.prototype.renderTeamCards = function () {
        var _this = this;
        var availablePermissions = this.props.availablePermissions;
        return this.teamResults.map(function (team) {
            if (team.type === "account") {
                return (react_1.default.createElement(CardsWithSuccessTransition_1.AccountCardWithSuccessTransition, { id: "account-card", key: "account-card", onClickHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, this.onCardClickWrapper(this.props.updateAccountPermission, team.id, this.permission)];
                            case 1: return [2, _a.sent()];
                        }
                    }); }); }, permission: false, handlePermissionChange: noopWithNullReturn, availablePermissions: availablePermissions }));
            }
            return (react_1.default.createElement(CardsWithSuccessTransition_1.TeamCardWithSuccessTransition, { id: "team-card-".concat(team.id), key: team.id, onClickHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2, this.onCardClickWrapper(this.props.updateTeamPermission, team.id, this.permission)];
                }); }); }, permission: false, name: team.name, handlePermissionChange: noopWithNullReturn, availablePermissions: availablePermissions }));
        });
    };
    ShareResourceSearch.prototype.renderUserCards = function () {
        var _this = this;
        return this.userResults.map(function (user) {
            switch (user.type) {
                case PermissionTypes_1.UserType.Existing:
                    return _this.renderExistingUserCard(user);
                case PermissionTypes_1.UserType.Pending:
                    return _this.renderPendingUserCard(user);
                default:
                    throw new Error("Unknown UserPermissionType: ".concat(JSON.stringify(user)));
            }
        });
    };
    ShareResourceSearch.prototype.renderExistingUserCard = function (user) {
        var _this = this;
        return (react_1.default.createElement(CardsWithSuccessTransition_1.UserCardWithSuccessTransition, { onClickHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.onCardClickWrapper(this.props.updateUserPermission, user.id, this.permission)];
                    case 1: return [2, _a.sent()];
                }
            }); }); }, firstName: user.firstName, lastName: user.lastName || "", email: user.email, key: user.id }));
    };
    ShareResourceSearch.prototype.renderPendingUserCard = function (user) {
        var _this = this;
        return (react_1.default.createElement(CardsWithSuccessTransition_1.PendingUserCardWithSuccessTransition, { key: user.id, onClickHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.onCardClickWrapper(this.props.updateUserPermission, user.id, this.permission)];
                    case 1: return [2, _a.sent()];
                }
            }); }); }, email: user.email }));
    };
    ShareResourceSearch.prototype.filterResults = function () {
        var _this = this;
        if (!this.searchTerm || this.searchTerm.length <= 0 || this.searchTerm.trim().length <= 0) {
            this.userResults = this.props.unpermittedUsers;
            this.teamResults = this.props.unpermittedTeams;
        }
        else {
            this.userResults = this.props.unpermittedUsers.filter(this.userMatchesSearch);
            var newTeamResults = this.props.unpermittedTeams.filter(function (res) {
                return (res.name || "").toLowerCase().includes(_this.searchTerm.toLowerCase());
            });
            this.teamResults = newTeamResults;
        }
    };
    Object.defineProperty(ShareResourceSearch.prototype, "hasUnpermittedUsersOrTeams", {
        get: function () {
            var _a = this.props, unpermittedTeams = _a.unpermittedTeams, unpermittedUsers = _a.unpermittedUsers;
            if (unpermittedTeams.length === 0 && unpermittedUsers.length === 0) {
                return false;
            }
            else {
                return true;
            }
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "showingSearchResults", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], ShareResourceSearch.prototype, "showError", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof Types_1.Action !== "undefined" && Types_1.Action) === "function" ? _a : Object)
    ], ShareResourceSearch.prototype, "permission", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "onSearchValueChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "clearSearch", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "onSelectPermission", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "showSearchResults", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "handleOnClick", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ShareResourceSearch.prototype, "hasUnpermittedUsersOrTeams", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ShareResourceSearch.prototype, "onSearchInputFocus", void 0);
    ShareResourceSearch = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ShareResourceSearch);
    return ShareResourceSearch;
}(react_1.default.Component));
exports.ShareResourceSearch = ShareResourceSearch;
var noopWithNullReturn = function () {
    return null;
};
